jQuery(document).ready(function($) {
    $("img").each(function() {
        var altText = $(this).attr("alt") || "Letterbox"; // Get alt text or default
        $(this).attr("title", altText); // Set title attribute (tooltip)
    });
});
